module.exports = __webpack_public_path__ + "static/media/delete-image.b066e292.svg";